// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconApplicationAdd = createRemixIcon('IconApplicationAdd', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.75.75h10.5v10.5H.75zm16 22.25v-3.75H13v-2.5h3.75V13h2.5v3.75H23v2.5h-3.75V23zm-16-10.25h10.5v10.5H.75zm2.5 2.5v5.5h5.5v-5.5zM14 .75h-1.25v10.5h10.5V.75zm1.25 8v-5.5h5.5v5.5z\" clip-rule=\"evenodd\"/>");
